
export const LAST_DATA_ACTION = {
  GET_DATA: 'LAST_DATA.GET_DATA',
  GET_DATA_SUCCESS: 'LAST_DATA.GET_DATA_SUCCESS',
}

export const getLastData = () => ({
  type: LAST_DATA_ACTION.GET_DATA,
});
